var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dialog',{ref:"dialog",attrs:{"title":"確認","message":"この権限を削除しますか。","loading":_vm.loading,"cancel-text":"いいえ","submit-text":"はい"},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }